/*============ SignIn-Out Controller ============*/
angular
    .module('vppApp')
    .controller('signInController', signInController);

signInController.$inject = ['$window', '$scope', '$rootScope', '$location', 'vppConfig', 'apiFactory', '$state', '$http', 'AuthenticationService', 'DTMTrackerService', '$stateParams', '$cookies'];

function signInController($window, $scope, $rootScope, $location, vppConfig, apiFactory, $state, $http, AuthenticationService, DTMTrackerService, $stateParams, $cookies) {
    var service = {};
    $scope.hideMe = false;
    if ($state.current.name === 'sign-in' && !($rootScope.siteCode === 'frd' || $rootScope.siteCode === 'mpp' || $rootScope.siteCode ==='gmed')) { AuthenticationService.destroyAuthentication(); };
    var userEmail;
    $scope.signInTemplate;
    if ($rootScope.siteCode === 'mpp') {
        $scope.signInTemplate = '/content/html/partials/global/idmesignin.html';
    } else if($rootScope.siteCode === 'gmed') {
        // if (location.hostname)
        $scope.signInLink = 'https://pop-uat.apps.pcfepgstg1mi.gm.com/EducatorAppreciationOffer';
        if (location.hostname.indexOf('gmeducatorappreciation.com') !== -1) {
            $scope.signInLink = 'https://exclusiveoffer.gm.com/EducatorAppreciationOffer';
        }
        $scope.signInTemplate = '/content/html/partials/global/gmedsignin.html';
    }
    else if ($rootScope.siteCode === 'frd') {
        $scope.signInTemplate = '/content/html/partials/global/frdsignin.html';
    }

    if ($rootScope.siteCode === 'ded') {
        apiFactory.gcVerify()
            .then(function successGCSignIn(response) {
                if (response.data.url != null) {
                    var date = new Date();
                    var expirationDate = new Date(date.setMonth(date.getMonth() + 6));
                    $cookies.put('createAccountDirect', false, { expires: expirationDate }); //createAccountDirect = false

                    $window.location.href = response.data.url;
                } else {
                    $location.path("/saml/login/" + response.data.accountId);
                }
            }, function errorCallback(response) {
                //   console.log(response.data.errors);
                $scope.serverError = response.data.errors;
                $state.go('index');
                // called asynchronously if an error occurs
                // or server returns response with an error status.
            });
    } else if ($scope.siteCode !== 'frd' && $scope.siteCode !== 'mpp' && $scope.siteCode !== 'gmed') {
        apiFactory.getSsoUrl().then(function (response) {
            $scope.ssoUrl = response.data;
            window.location.href = $scope.ssoUrl;
        });
    }

    $scope.setFrdPosition = function (frdPosition) {
        $rootScope.frdPosition = frdPosition;
        //$rootScope.tempAPISite = frdPosition;
    }


    $scope.submitSignIn = function (userData) {
        userEmail = userData.username;
        userData.Token = $location.search().token;
        var userDetail;

        apiFactory.signIn(userData).then(function successSignIn(response) {

            apiFactory.getCustomer(response.data.accountID).then(function (response2) {
                userDetail = response2;

                AuthenticationService.setAuthentication(response, userEmail, userDetail);

                DTMTrackerService.updatePageLoadData('universalID', AuthenticationService.createUniqueID());
                DTMTrackerService.directCall("signin-complete");
                //$rootScope.isAuth = true;
                if ($rootScope.returnToState) {
                    $state.go($rootScope.returnToState);
                } else {
                    $state.go("view-auth");
                }
                $rootScope.showGetAuthCTA = false;
                // this callback will be called asynchronously
                // when the response is available

            }, function errorCallback(response) {
                //console.log(response.data.errors);
                AuthenticationService.destroyAuthentication();
                $scope.serverError = response.data.errors;
                // called asynchronously if an error occurs
                // or server returns response with an error status.
            });

        }, function errorCallback(response) {
            AuthenticationService.destroyAuthentication();
            $scope.serverError = response.data.errors;
            // called asynchronously if an error occurs
            // or server returns response with an error status.
        });
    };


    $scope.submitSignOut = function () {
        apiFactory.signOut().then(function successSignOut(response) {
            if (response.data.url != null) {
                $window.location.href = response.data.url;
            } else {
                $state.go("index");
            }
            // this callback will be called asynchronously
            // when the response is available
        }, function errorCallback(response) {
            $scope.serverError = response.data.errors;
            // called asynchronously if an error occurs
            // or server returns response with an error status.
        });
    };


    $scope.idMeFactoryCall = function () {
        apiFactory.idMeAccessUserData().then(function (response) {
            if (AuthenticationService.isAuthenticated()) {
                $state.go('get-auth');
            }
            else if (response.data.accountID && response.data.idMeIdentifier) {
                $location.path("/saml/login/" + response.data.accountID);
            }
            else {
                $state.go('create-account');
            }

        }, function errorCallback(response) {
            $scope.serverError = response.data.errors;
            // called asynchronously if an error occurs
            // or server returns response with an error status.
        });
    };


    $scope.dispSignIn = function (userData) {
        $scope.hideMe = true;
    };
}
